import { render, staticRenderFns } from "./ParticaCard.vue?vue&type=template&id=f0536df8&scoped=true&"
import script from "./ParticaCard.vue?vue&type=script&lang=ts&"
export * from "./ParticaCard.vue?vue&type=script&lang=ts&"
import style0 from "./ParticaCard.vue?vue&type=style&index=0&id=f0536df8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0536df8",
  null
  
)

export default component.exports